
import { CharacterFeatureSource } from "@dndModels/character_feature_source/CharacterFeatureSource";
import { 
  OrgPosition,
  OrgInstance
} from "@dndModels";

export class CharacterOrg extends CharacterFeatureSource {
  source: OrgPosition | null = null;
  position = 0;
  org_instance_id = "";
  org_instance: OrgInstance | null = null;

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.position = obj.position ? obj.position : 0;
      this.org_instance_id = obj.org_instance_id ? obj.org_instance_id : "";
    }
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      position: this.position,
      org_instance_id: this.org_instance_id
    };
  }

  clone(drop_ids = false): CharacterOrg {
    const clone = new CharacterOrg();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: CharacterOrg, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.source = copyMe.source;
    this.position = copyMe.position;
    this.org_instance_id = copyMe.org_instance_id;
  }
}